import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { CompanyProvider } from "@/context/CompanyContext";
import { ConfirmDialogProvider } from "@/components/ConfirmDialog";
import PublicLayout from "@/components/PublicLayout";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Servicios from "@/pages/Servicios";
import Soluciones from "@/pages/Soluciones";
import { CasosList, CasoDetail } from "@/pages/Casos";
import Cotizador from "@/pages/Cotizador";
import Contacto from "@/pages/Contacto";
import Privacidad from "@/pages/Privacidad";
import Terminos from "@/pages/Terminos";
import Utilities from "@/pages/Utilities";
import UtilitiesHub from "@/pages/UtilitiesHub";
import IvaCalculator from "@/pages/IvaCalculator";
import BoletaCalculator from "@/pages/BoletaCalculator";
import IpcCalculator from "@/pages/IpcCalculator";
import BencinasCalculator from "@/pages/BencinasCalculator";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminProposals from "@/pages/admin/AdminProposals";
import AdminProposalEditor from "@/pages/admin/AdminProposalEditor";
import AdminCRM from "@/pages/admin/AdminCRM";
import AdminAgenda from "@/pages/admin/AdminAgenda";
import AdminImplementations from "@/pages/admin/AdminImplementations";
import AdminCompanies from "@/pages/admin/AdminCompanies";
import AdminTerms from "@/pages/admin/AdminTerms";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminOnlyRoute from "@/components/AdminOnlyRoute";

function App() {
  return (
    <div className="App font-body">
      <AuthProvider>
        <CompanyProvider>
        <ConfirmDialogProvider>
          <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Public */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/servicios" element={<Servicios />} />
              <Route path="/soluciones" element={<Soluciones />} />
              <Route path="/casos" element={<CasosList />} />
              <Route path="/casos/:slug" element={<CasoDetail />} />
              <Route path="/cotizador" element={<Cotizador />} />
              <Route path="/contacto" element={<Contacto />} />
              <Route path="/privacidad" element={<Privacidad />} />
              <Route path="/terminos" element={<Terminos />} />
              <Route path="/utilidades" element={<UtilitiesHub />} />
              <Route path="/utilidades/rut" element={<Utilities />} />
              <Route path="/utilidades/iva" element={<IvaCalculator />} />
              <Route path="/utilidades/boleta" element={<BoletaCalculator />} />
              <Route path="/utilidades/ipc" element={<IpcCalculator />} />
              <Route path="/utilidades/bencinas" element={<BencinasCalculator />} />
            </Route>

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route element={<AdminOnlyRoute />}>
                <Route path="leads" element={<AdminLeads />} />
                <Route path="quotes" element={<AdminQuotes />} />
                <Route path="admin/companies" element={<AdminCompanies />} />
                <Route path="terms" element={<AdminTerms />} />
                <Route path="users" element={<AdminUsers />} />
              </Route>
              <Route path="proposals" element={<AdminProposals />} />
              <Route path="proposals/new" element={<AdminProposalEditor />} />
              <Route path="proposals/:id" element={<AdminProposalEditor />} />
              <Route path="crm" element={<AdminCRM />} />
              <Route path="agenda" element={<AdminAgenda />} />
              <Route path="implementations" element={<AdminImplementations />} />
            </Route>
          </Routes>
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#12161A",
                border: "1px solid #2A323A",
                color: "#F0F4F8",
                borderRadius: 0,
              },
            }}
          />
        </BrowserRouter>
        </ConfirmDialogProvider>
        </CompanyProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
